import undefsafe from 'undefsafe'

const authorizators = {
  userIsAuthor: (user, _site) => {
    return undefsafe(user, 'profile.is_author')
  },
  userIsNotAuthor: (user, _site) => {
    const isAuthor = undefsafe(user, 'profile.is_author')
    return isAuthor === undefined || isAuthor === false
  },
  canViewAdmin: (user, _site) => {
    return undefsafe(user, 'profile.permissions.global.can_view_admin_menu')
  },
  hasAuthorPermissionsInCurrentSite: (user, site) => {
    return undefsafe(user, `profile.permissions.${site}.author_permissions`)
  },
  canUploadInCurrentSite: (user, site) => {
    return undefsafe(user, `profile.permissions.${site}.can_upload`)
  },
  canViewPortfolio: (user, site) => {
    return undefsafe(user, `profile.permissions.${site}.can_view_portfolio`)
  }
}

export const canUser = (user, permission, site = null) => {
  if (user) {
    const authorizator = authorizators[permission]
    if (authorizator) {
      return authorizator(user, site) === true
    } else {
      throw new Error(`Couldn't find permission with name ${permission}`)
    }
  } else {
    return false
  }
}



// WEBPACK FOOTER //
// ./common/utils/userAuthorization.js